<template>
  <div class="tooltip scatter-tooltip">
    <div class="tooltip-content">
      <div class="header">
        <div class="top">
          <div class="subject-id">{{$t('subject')}} {{data.subject.templateId}}</div>
          <div class="arrythmia" v-if="isArrythmic">Arrythmic</div>
        </div>
        <div class="bottom">
          <div class="trial">{{data.trialMeta.name}}</div>
          <div v-if="!data.isImported" class="goto" @click="goToResultDashboard">{{$t('view_results_for_this_case')}}</div>
        </div>
      </div>
      <div class="stats"
      v-bind:class='{"healthy": !isArrythmic, "arrythmic": isArrythmic}'>
        <cohort-fields :patient="data"></cohort-fields>
      </div>
      <div class="globals"
      v-bind:class='{"healthy": !isArrythmic, "arrythmic": isArrythmic}'>
        <div class="global-item" v-for="v in globalValues" :key="v.label">
          <span class="global-label">{{v.label}}</span>
          <span class="global-value">{{v.value}}</span>
        </div>
      </div>
    </div>
    <div class="tooltip-arrow" data-popper-arrow></div>
  </div>
</template>

<script>
import CohortFields from '@/components/commons/CohortFields'

export default {
  name: 'ScatterTooltip',
  props:['data'],
  components: {
    CohortFields
  },
  // asyncComputed:{
  //   trial(){
  //     return Api.getTrial({project: this.$route.params.project,trial: this.data.trialId})
  //   }
  // },
  computed:{
    isArrythmic() {
      return this.data.scalars.some(s => s.value == null)
    },
    globalValues () {
      return this.data.scalars.map(e => {
        if (e.value != null) {
          return {
            label: e.name,
            value: e.value.toFixed(3)
          }
        } else {
          return {
            label: e.name,
            value: '-'
          }
        }
      })
    },
  },
  methods: {
    goToResultDashboard() {
      this.$store.state.trialToShowInResultsCrumb = `trial#${this.data.trialId}`
      this.$router.push({path: `/project/${this.data.trialMeta.project}/results/trial/${this.data.trialId}/subject/${this.data.subject.templateId}`})
    }
  }
}
</script>

<style lang="stylus" scoped>
.tooltip
  .tooltip-arrow
    display: none

  .tooltip-content
    border-radius: 4px
    overflow: hidden

    .header
      display: flex
      flex-direction: column
      padding: 10px
      background-color: rgba($tuna, 0.75)

      .top
        display: flex
        m-font-size(12, 14)
        justify-content: space-between

      .bottom
        display: flex
        m-font-size(10, 12)

        .trial
          flex: 1 1 0

        .goto
          font-style: italic
          cursor pointer
          &:hover
            text-decoration underline

    .stats
      padding: 10px
      &.healthy
        background-color: $bright-gray
      &.arrythmic
        background-color: rgba(red, 0.15)

    .globals
      border-top: 1px solid $storm-gray
      display: flex
      flex-wrap: wrap
      m-font-size(10, 12)
      &.healthy
        background-color: $bright-gray
      &.arrythmic
        background-color: rgba(red, 0.15)

      .global-item
        align-items: center
        border-bottom: 1px solid $storm-gray
        border-right: 1px solid $storm-gray
        display: flex
        flex: 0 0 percentage((1 / 4))
        // overflow: hidden
        padding: 5px

        .global-label
          color: rgba(#fff, 0.5)
          margin-right: 5px
          text-transform: uppercase
</style>